import axios from "axios";
import setAuthToken from "../global/setAuthToken";
import store from "store";
export async function login(contact1, password1) {
  const value = { username: contact1, password: password1 };
  let authorized1 = false;
  return axios
    .post(`/api/loginV2`, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: ``,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        authorized1 = true;
        // const expirationDate = new Date(new Date().getTime() + 3600 * 10000);
        localStorage.setItem("token", response.data.token);
        store.set("user", response.data.user);

        // localStorage.setItem("expirationDate", expirationDate);

        setAuthToken(localStorage.getItem("token"));
        // setCart(response.data.user.id);
        return {
          id: response.data.user.id,
          authorized: authorized1,
          contact: response.data.user.conatct,
          role: response.data.user.roles,
          email: response.data.user.email,
          token: response.data.token,
        };
      } else if (response.status !== 200) {
        // toast(JSON.stringify(response.data.non_field_errors), {
        //   type: "error",
        //   autoClose: 2000,
        // });
      }
    })
    .catch((error) => {
      //   toast("Invalid Credential", { type: "error", autoClose: 2000 });
      // notification.warning({
      //   message: error.code,
      //   description: error.message,
      // });
    });
}

export async function currentAccount(role) {
  let authorized1 = false;
  const user = store.get("user");
  const session = store.get("session");
  if (role === 9) {
    return axios
      .get(
        `/api/session_student?user__id=${user.id}&student__student_status=currentlystudying&session=${session.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        authorized1 = true;
        return {
          studentData: response.data.results[0].student,
          student_class: response.data.results[0].student_class,
          student_section: response.data.results[0].section,
          student_info: response.data.results[0],
        };
      })
      .catch((error) => {
        // toast("Invalid Token Id or Session is Lost", { type: "warning" });
        // notification.warning({
        //   message: "Invalid Token Id or Session is Lost",
        //   description: error.message,
        // });
      });
  } else {
    return axios
      .get(`/api/staff?user=${user.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        authorized1 = true;
        return {
          staffData: response.data.results[0],
        };
      })
      .catch((error) => {});
  }
}

export async function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("student_info");
  localStorage.removeItem("student_class");
  localStorage.removeItem("studentData");
  localStorage.removeItem("student_section");
  localStorage.removeItem("staffData");
  localStorage.removeItem("session");
  localStorage.removeItem("role");
  // store.set("user", {});
  setAuthToken("");
  window.localStorage.clear();
  window.location.reload();
}

// ============User ID Information==============
// IS_SUPERADMIN = 1;
// IS_ADMIN = 2;
// IS_TEACHER = 3;
// IS_LIBRARIAN = 4;
// IS_ACCOUNTANT = 5;
// IS_EMPLOYEE = 6;
// IS_DRIVER = 7;
// IS_PARENT = 8;
// IS_STUDENT = 9;
// IS_PRINCIPAL = 10;
// IS_RECEPTIONIST = 11;
// IS_STOREMANAGER = 12;
// IS_ACADEMICINC = 13;
